export function trimNullableString(inputString: string | undefined | null): string {
  if (inputString === undefined || inputString === null) {
    return "";
  } else {
    return inputString.trim();
  }
}
